import * as React from 'react';
import { RouteComponentProps, Switch, Route } from 'react-router';
import { connect, Dispatch } from 'react-redux';
import { Layout } from 'antd';
import { push } from 'react-router-redux';
import { AppState } from 'src/store';
import { Toast } from 'src/toast';
import { SideNav, TopBar } from 'src/layout';
import { userIsAuthenticated } from 'src/authWrapper';
import Tools from 'src/tools';

import { MerchantList, CreateOrEditMerchant, ViewMerchant, ResetPassword } from 'src/merchants';
import { CategoryList, CreateOrEditCategory } from 'src/categories';
import { FeaturedAdsList, CreateOrEditFeaturedAds } from 'src/featuredAds';
import { MemberList } from 'src/members';
import { FeaturedCategoriesList, CreateOrEditFeaturedCategory } from 'src/featuredCategories';
import { TrendingCategoryList, CreateOrEditTrendingCategory } from 'src/trendingCategories';
import { MerchantStatus, MerchantDetail } from 'src/dashboards';

const { Header, Content, Footer } = Layout;

const ProtectedMerchantStatus = userIsAuthenticated(MerchantStatus);
const ProtectedMerchantDetail = userIsAuthenticated(MerchantDetail);
const ProtectedMerchantUserResetPassword = userIsAuthenticated(ResetPassword);
const ProtectedCategoryList = userIsAuthenticated(CategoryList);
const ProtectedCreateOrEditCategory = userIsAuthenticated(CreateOrEditCategory);
const ProtectedFeaturedAdsList = userIsAuthenticated(FeaturedAdsList);
const ProtectedCreateOrEditFeaturedAds = userIsAuthenticated(CreateOrEditFeaturedAds);

const ProtectedFeaturedCategoriesList = userIsAuthenticated(FeaturedCategoriesList);
const ProtectedCreateOrEditFeaturedCategory = userIsAuthenticated(CreateOrEditFeaturedCategory);

const ProtectedTrendingCategoryList = userIsAuthenticated(TrendingCategoryList);
const ProtectedCreateOrEditTrendingCategory = userIsAuthenticated(CreateOrEditTrendingCategory);

const ProtectedMerchantList = userIsAuthenticated(MerchantList);
const ProtectedCreateOrEditMerchant = userIsAuthenticated(CreateOrEditMerchant);
const ProtectedViewMerchant = userIsAuthenticated(ViewMerchant)

const ProtectedMemberList = userIsAuthenticated(MemberList);

const ProtectedTools = userIsAuthenticated(Tools);

const mapStateToProps = (state: AppState) => {
  return {

  };
};

const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
  return {
    onMenuClick: (item: { key: string }) => {
      dispatch(push(`/${item.key}`));
    },
  };
};

interface Props extends RouteComponentProps<{}> {
  onMenuClick: (item: { key: string }) => void;
}

class Root extends React.Component<Props> {
  render() {
    const { onMenuClick } = this.props;
    return (
      <div className="App">
        <Toast />
        <Layout style={{ minHeight: '100vh' }}>
          <SideNav onMenuClick={onMenuClick} />
          <Layout>
            <Header><TopBar /></Header>
            <Content>
              <Switch>
                <Route exact={true} path="/" component={ProtectedMerchantStatus} />
                <Route path="/dashboards/merchantStatus" component={ProtectedMerchantStatus} />
                <Route path="/dashboards/merchantDetail" component={ProtectedMerchantDetail} />
                <Route path="/dashboards" component={ProtectedMerchantStatus} />
                
                <Route path="/categories/create" component={ProtectedCreateOrEditCategory} />
                <Route path="/categories/edit/:id" component={ProtectedCreateOrEditCategory} />
                <Route path="/categories" component={ProtectedCategoryList} />

                <Route path="/featuredAds/create" component={ProtectedCreateOrEditFeaturedAds} />
                <Route path="/featuredAds/edit/:id" component={ProtectedCreateOrEditFeaturedAds} />
                <Route path="/featuredAds" component={ProtectedFeaturedAdsList} />

                <Route path="/featuredCategories/create" component={ProtectedCreateOrEditFeaturedCategory} />
                <Route path="/featuredCategories/edit/:id" component={ProtectedCreateOrEditFeaturedCategory} />
                <Route path="/featuredCategories" component={ProtectedFeaturedCategoriesList} />

                <Route path="/trendingCategories/create" component={ProtectedCreateOrEditTrendingCategory} />
                <Route path="/trendingCategories/edit/:id" component={ProtectedCreateOrEditTrendingCategory} />
                <Route path="/trendingCategories" component={ProtectedTrendingCategoryList} />

                <Route path="/merchants/:merchantId/users/resetpassword/:id" component={ProtectedMerchantUserResetPassword} />

                <Route path="/merchants/create" component={ProtectedCreateOrEditMerchant} />
                <Route path="/merchants/edit/:id" component={ProtectedCreateOrEditMerchant} />
                <Route path="/merchants/view/:id" component={ProtectedViewMerchant} />
                <Route path="/merchants" component={ProtectedMerchantList} />
                
                <Route path="/members" component={ProtectedMemberList} />
                <Route path="/tools" component={ProtectedTools} />
              </Switch>
            </Content>
            <Footer>
              <span>&copy; {new Date().getFullYear()} Data Focus Pte Ltd</span>
              <span id="commit-hash">{__COMMIT_HASH__}</span>
            </Footer>
          </Layout>
        </Layout>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Root);



// WEBPACK FOOTER //
// ./src/Root.tsx